import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { ThemeService } from '@core/services';
import { Subscription } from 'rxjs';
import { MatNavList, MatListItem } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    imports: [MatNavList, MatListItem, RouterLink, RouterLinkActive, MatIcon]
})
export class SidenavComponent implements OnInit, OnDestroy {
  private themeSubscription!: Subscription;
  currentTheme: string | undefined;

  constructor(private router: Router, private themeService: ThemeService) { }

  ngOnInit(): void {
    this.themeSubscription = this.themeService.getThemeObservable().subscribe(theme => {
      this.currentTheme = theme;
    });
  }

  ngOnDestroy(): void {
    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe();
    }
  }

  getActiveClass(url: string) {
    if (this.router.url.indexOf(url) > 0) {
      return true;
    }

    return false;
  }
}
